import React from "react";
import dayjs from "dayjs";

const RenderMeetingDate = ({ meeting, isCompleted = false }) => {
    let meetingDate = null;
    let display = "Not specified";
    let warning = false;

    if (!!meeting?.status === "completed") isCompleted = true;

    if (!!meeting?.date) {
        meetingDate = meeting.date;
        display = new Date(meetingDate).toLocaleString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });

        // open appraisal with expired meeting date
        if (!isCompleted && dayjs().isAfter(meetingDate, "day")) {
            warning = true;
        }
    } else {
        // open appraisal with no meeting date
        if (!isCompleted) warning = true;
    }

    return <span className={warning ? "error" : ""}>{display}</span>;
};

export default RenderMeetingDate;
